/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Legal_TitleInputs */

const en_meta_legal_title = /** @type {(inputs: Meta_Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Information | Lindevo`)
};

const lv_meta_legal_title = /** @type {(inputs: Meta_Legal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekvizīti | Lindevo`)
};

/**
* | output |
* | --- |
* | "Legal Information \| Lindevo" |
*
* @param {Meta_Legal_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_legal_title = /** @type {((inputs?: Meta_Legal_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Legal_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_legal_title(inputs)
	return en_meta_legal_title(inputs)
});